export enum paylineAssetConfig {
    // JSON_PAYLINE_1 = "assets/payline/Payline01_0_to_30.json",
    //
    // JSON_PAYLINE_4_A = "assets/payline/Payline04_0_to_7.json",
    // JSON_PAYLINE_4_B = "assets/payline/Payline04_8_to_15.json",
    // JSON_PAYLINE_4_C = "assets/payline/Payline04_16_to_23.json",
    // JSON_PAYLINE_4_D = "assets/payline/Payline04_24_to_30.json",
    // JSON_PAYLINE_5_A = "assets/payline/Payline05_0_to_7.json",
    // JSON_PAYLINE_5_B = "assets/payline/Payline05_8_to_15.json",
    // JSON_PAYLINE_5_C = "assets/payline/Payline05_16_to_23.json",
    // JSON_PAYLINE_5_D = "assets/payline/Payline05_24_to_30.json",
}